<template>
  <div class="side-bar-payments-list">
    Принимаем
    <v-popover
      class="side-bar-payments-list__tooltip-button"
      placement="top"
      trigger="manual"
      :open="isOpen"
      @hide="setIsOpen(false)"
    >
      <pseudo-link @click.prevent="toggleIsOpen">
        все виды оплаты
      </pseudo-link>

      <template #popover>
        <payments-list />
      </template>
    </v-popover>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';

import useTooltip from '@/compositions/useTooltip';

import PseudoLink from '@/components/PseudoLink/index.vue';
import PaymentsList from '@/components/_desktop/SideBarPaymentsList/PaymentsList/index.vue';

export default defineComponent({
  name: 'SideBarPaymentsList',
  components: {
    PseudoLink,
    PaymentsList,
  },
  setup() {
    const tooltip = useTooltip();

    return {
      ...tooltip,
    };
  },
});
</script>

<style lang="less">
.side-bar-payments-list {
  display: flex;

  &__tooltip-button {
    margin-left: @main-size;
  }
}
</style>
